module.exports = __webpack_public_path__ + "@/assets/img/mobiles1.3e321309.png";